import type { AllRouteEndpoints } from "../routeTypes";
export const engagementExportLogsCancelCacheKeys: AllRouteEndpoints[] = [
  "/engagement/export_logs/:log_id/:app_group_id",
  "/engagement/export_logs",
];
